import React, { Fragment } from 'react';
import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ArcaHttpClientPet } from '../../../code/ArcaHttpClientPet';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ModalPopup } from '../ModalPopup';
import { InputField } from './InputField';

export class PetMultiSelect2 extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            selectedPets: this.props.selectedPets,
            pets: null,
            refresh: false,
            searchString: null,
            popupVisible : false
        };
    }

    async componentDidMount() {
        this.getPetList('ALL');
    }

    async getPetList(filter) {
        ArcaHttpClientPet.GetListAsync(
            filter,
            (pets => this.petListReceived(pets)),
            (status => alert(status))
        );
    }

    petListReceived(pets) {
        pets.map(p => {
            p.Selected = this.state.selectedPets
                .some(sp => sp.Id === p.Id);
        });

        this.setState({ pets });
    }

    render() {

        //let groupFullPopup = this.state.numberFullPopup ?
        //    <ModalPopup
        //        title={`Maximum group size has been reach`}
        //        text={`The maximum group size must not exceed '${this.props.maxNumberToSelect}'.`}
        //        onCancel={(() => this.setState({ numberFullPopup: false }))}
        //    /> : null
    

        return (
            <Modal isOpen={true}>
                <ModalHeader>
                    Pet selection
                </ModalHeader>
                <ModalBody>
                    <Button color="primary" onClick={this.onConfirm.bind(this)}>Confirm</Button>{' '}
                    <Button color="secondary" onClick={this.onCancel.bind(this)}>Cancel</Button>
                    <hr />

                    {/*{groupFullPopup}*/}

                    <table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>

                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Selected - {this.state.selectedPets.length} of {this.props.maxNumberToSelect} slot(s)</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {this.state.selectedPets?.map((pet, key) =>
                                        <Fragment key={key}>
                                            <h6>
                                                <Badge pill
                                                    key={key}
                                                    style={{ 'cursor': 'pointer' }}
                                                    color={pet.Added ? 'secondary' : "primary"}
                                                    onClick={this.onSelectedPetClicked.bind(this, pet)}>
                                                    {pet.FullName} - {pet.OwnerName}
                                                </Badge>
                                                {'  '}
                                            </h6>
                                        </Fragment>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <InputField
                        fieldname='Filter ..'
                        regularExpression='free'
                        warnText='Invalid search text format'
                        mandatory={false}
                        showHeader={false}
                        onUpdate={this.onSearchStringChange.bind(this)}
                        fieldValid={true} />

                    <table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>

                        </thead>
                        <tbody>
                            {this.state.pets?.filter((p) => !p.Selected).map((pet, key) =>
                                <tr key={key}>
                                    <td>
                                        <Badge
                                            style={{ 'cursor': 'pointer' }}
                                            color={pet.Selected ? 'primary' : 'light'}
                                            onClick={this.onPetClicked.bind(this, pet)}>
                                            {pet.FullName} - {pet.OwnerName}
                                        </Badge>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }

    onSearchStringChange(searchString) {
        this.getPetList(searchString);
    }

    onSelectedPetClicked(pet) {

        var newList = this.state.selectedPets.filter(sp => sp.Id !== pet.Id);
        var removedPet = this.state.selectedPets.find(p => p.Id === pet.Id);
        removedPet.Added = false;
        removedPet.Selected = false;

        this.state.pets.push(removedPet)

        this.setState({
            refresh: true,
            selectedPets: newList,
            pets: this.state.pets
        });
    }

    onPetClicked(pet) {

        let { selectedPets } = this.state;

        //if (selectedPets.length >= this.props.maxNumberToSelect) {
        //    this.setState({ numberFullPopup: true })
        //    return;
        //}

        pet.Selected = !pet.Selected
        pet.Added = true;
        var newList = [];

        if (pet.Selected)
            newList.push(pet);

        for (var i = 0; i < selectedPets.length; i++) {
            var p = selectedPets[i];
            if (p.Id !== pet.Id)
                newList.push(p)
        };

        this.setState({
            refresh: true,
            selectedPets: newList
        });
    }

    onConfirm() {
        this.props.onConfirm(this.state.selectedPets);
    }

    onCancel() {
        this.props.onCancel();
    }
}